import { RadixApp } from '../../types/radixApp';
import { RadixClusterInfo } from '../../hooks/useRadixClusters';

export const RADIX_APPS_ANNOTATION = 'equinor.com/radix-apps';

const RADIX_APP_ENTRY_PATTERN = /^([^/@,\s]+)\/([^/@,\s]+)$/;

export function radixAppsFromAnnotation(
  annotations: Record<string, string> | undefined,
  clusters: RadixClusterInfo[],
): RadixApp[] {
  const raw = annotations?.[RADIX_APPS_ANNOTATION];
  if (!raw) {
    return [];
  }

  const clusterById = new Map(clusters.map(cluster => [cluster.id, cluster]));

  return raw
    .split(',')
    .map(entry => RADIX_APP_ENTRY_PATTERN.exec(entry.trim()))
    .filter((match): match is RegExpExecArray => match !== null)
    .flatMap(([, name, clusterId]) => {
      const cluster = clusterById.get(clusterId);
      if (!cluster) {
        return [];
      }

      return [
        {
          name,
          consoleUrl: `https://console.${cluster.host}/applications/${encodeURIComponent(name)}`,
          category: cluster.category,
          clusterId: cluster.id,
          clusterLabel: cluster.label,
        },
      ];
    });
}
